window._define('utils/log', ['app/core', 'common/pubsub'], function (core, pubsub) {
    'use strict';
    var now = Date.now();

    pubsub.subscribe(pubsub.EVENT.LOG, function (eventName, message) {
        core.log('%c %s %c ' + message, 'background-color:green;color:white;', (Date.now() - now), 'color:black');
    });

});
